import { render, staticRenderFns } from "./news.vue?vue&type=template&id=259f0f03&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=259f0f03&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./news.vue?vue&type=style&index=1&id=259f0f03&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f0f03",
  null
  
)

export default component.exports